import styled from 'styled-components';
import { Typography } from '../../../assets/styles/StyleTypes';

export const Table = styled.div`
  width: 100%;
  height: 100%;
  ${Typography.HELPER_XXS}
  color: ${(props) => props.theme.colors.textPrimary};
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media screen and (max-width: 960px) {
    &#table-equipments,
    &#table-update-equipments {
      border-radius: 10px;
      box-shadow: 0 0 0.7em ${props => props.theme.colors.boxShadow};
      margin-top: 20px;
    }

    &#recipes-executions {
      width: auto;
      min-width: 800px;
      overflow-x: auto;
    }
  }
`;

